// LOAD-PERF (owner 2026-11-02: "load assets, shaders, everything quickly … the bulk of the loading at the beginning"):
// downloads that boot() starts first thing, before the renderer is even up, so they run in parallel with it:
//  - Rapier + three-pinata (render-only debris physics; a separate ~4 MB chunk, off the main bundle) and Rapier's WASM init;
//  - the hero model (fetched + parsed once, shared by the hero and every ghost copy: GltfHero.fetchGlb).
// index.html also preloads the hero GLB from the first byte of HTML. Nothing here decides gameplay.
import { loadPhysics } from '../render/debris';
import { GltfHero } from '../render/heroGltf';

export function startEarlyLoads(params: URLSearchParams): void {
  void loadPhysics().catch((e) => console.warn('[preload] physics', e)); // debris.init() awaits the same promise
  if (params.get('hero') === 'procedural') return;
  // the same file view.setHeroModel('gltf') picks
  const file = GltfHero.heroFile(params);
  void GltfHero.fetchGlb(`${import.meta.env.BASE_URL}models/${file}`).catch(() => { /* the view falls back to the procedural rig */ });
}
